// The ONLY place the product brand and canonical origin live in the SPA.
// Rename the product or move domains by changing the values here and the
// matching Vercel env vars — nothing else in src/ should hardcode either.

const env = import.meta.env;
const trimSlash = (s: string) => s.replace(/\/+$/, '');

export const APP_CONFIG = {
  /** Product name: <title>, wordmark, logo alt text, in-app copy. */
  name: 'Steddy',
  tagline: '360 Job Management',
  /**
   * Canonical origin for links we hand to Supabase Auth (emailRedirectTo) and
   * copy-to-clipboard invite links. VITE_APP_URL pins it in Vercel Production;
   * previews and local dev fall back to the current origin, which is what
   * those flows actually want.
   */
  appUrl: trimSlash((env.VITE_APP_URL ?? '').trim()) || window.location.origin, // prod: https://app.steddyhq.com
  /**
   * Preview-only mirror of the edge-function PLATFORM_MAIL_DOMAIN secret, used
   * to show a tenant their default sending address before a send confirms it.
   */
  platformMailDomain: (env.VITE_PLATFORM_MAIL_DOMAIN ?? '').trim() || 'mail.steddyhq.com',
} as const;
